
window.placeholderPolyfill = function () {
    this.classList[this.value ? 'remove' : 'add']('placeholder-shown');
};

window.flash = function (message, type) {
    EventBus.$emit('flash_' + type, { message });
};

window.flash_success = function (message) {
    flash(message, 'success');
};

window.flash_message = function (message) {
    flash(message, 'message');
};

window.flash_error = function (message) {
    flash(message, 'error');
};

window.has_permission = function (name) {
    return window.App.permissions.indexOf(name) > -1;
};

window.format_sek = function (amount) {
    if (window.Intl && typeof window.Intl === 'object') {
        return new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(amount);
    }

    return amount + ' kr';
};

window.get_request_value = (requestKey) => {
    const queryString = window.location.search;
    if (! queryString) {
        return null;
    }

    const queryParam = new URLSearchParams(queryString).get(requestKey);

    return queryParam === '' ? null : queryParam;
};
